//src/pages/reports/clientes/ClienteReportsLayout.tsx
import { Outlet, NavLink } from 'react-router-dom';
import { Box, Typography, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import PeopleIcon from '@mui/icons-material/People';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import CancelIcon from '@mui/icons-material/Cancel';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { useTranslation } from 'react-i18next';
import GradeIcon from '@mui/icons-material/Grade';
const linkSx = (active: boolean) => ({
  bgcolor: active ? 'action.selected' : 'transparent',
  color: active ? 'primary.main' : 'text.primary',
  '& .MuiListItemIcon-root': { color: active ? 'primary.main' : 'inherit' },
});

export default function ClienteReportsLayout() {
  const { t } = useTranslation<'translation'>();
  return (
    <Box sx={{ display: 'flex', minHeight: '100%' }}>
      {/* ────────── menú lateral ────────── */}
      <Box
        sx={{
          width: 220,
          borderRight: 1,
          borderColor: 'divider',
          px: 2,
          py: 3,
        }}
      >
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {t('clienteReportsLayout.titulo')}
        </Typography>

        <List dense disablePadding>
          {/* Horas semanales */}
          <NavLink to="semanal">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <BarChartIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('clienteReportsLayout.menu.horasSemanales')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="profesor">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <PeopleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('clienteReportsLayout.menu.profesores')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="one-minute-paper">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <NoteAltIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Ejercicio de inicio de clase" />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="incidencias">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <ReportProblemIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('clienteReportsLayout.menu.incidencias')} />
              </ListItemButton>
            )}
          </NavLink>
          {/* Retrasos */}
          <NavLink to="retrasos">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <ScheduleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('clienteReportsLayout.menu.retrasos')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="progreso">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <BarChartIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('clienteReportsLayout.menu.progreso')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="proyecto">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <InsertChartIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('clienteReportsLayout.menu.proyecto')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="total-unicos">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <PeopleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('clienteReportsLayout.menu.totalUnicos')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="cancelacion">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <CancelIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('clienteReportsLayout.menu.cancelacion')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="evaluaciones">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <GradeIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('clienteReportsLayout.menu.evaluaciones')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="altas-bajas">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <TrendingUpIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Altas vs Bajas" />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="mensual">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <BarChartIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('Mensuales')} />
              </ListItemButton>
            )}
          </NavLink>
        </List>
      </Box>

      {/* ────────── contenido ────────── */}
      <Box sx={{ flex: 1, p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
